module.exports = __webpack_public_path__ + "static/bnr_wide-cf65184f340bf411689cdca650112de2.webp";